import { useDispatch, useSelector } from 'react-redux';

import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import ModalSuccess from '../components/ModalSuccess';
import { modalOpen } from '../modalActions';
import { IModalRenderProps } from '../types/modalTypes';


export const useModalOpenSuccess = () => {

    const dispatch = useDispatch();

    const { modal } = useSelector(makeSelectTranslationCommon());

    const open = (title: string, onClose?: () => void) => {
        dispatch(modalOpen({
            onCloseCallback: () => {
                onClose?.();
            },
            render: (props: IModalRenderProps) => <ModalSuccess
                title={title}
                translation={modal}
                onCloseModal={props.onCloseModal}
            />,
        }));
    };

    return { open };
};
